import { Fragment } from 'react'
import styled, { css } from 'styled-components'

const RenderAgeWrapper = styled.div`
	width: 100%;
	text-align: center;
	margin: 32px 0;
	${props =>
		props.templateTwo &&
		css`
			margin: 24px 0 20px 0;
		`}
`

const HeadingText = styled.p`
	font-weight: 600;
	font-size: 15px;
	line-height: 20px;
	color: #999999;
	letter-spacing: -0.02em;
	margin-bottom: 16px;

	i {
		font-size: 16px;
		vertical-align: -2px;
		margin-right: 4px;
	}
`

const SelectWrapper = styled.div`
	position: relative;
	display: inline-block;
	vertical-align: top;
	margin: 0 1px 4px;

	&:after {
		${props =>
			props.templateTwo &&
			css`
				content: '\\e982';
				font-weight: 600;
			`}

		${props =>
			!props.templateTwo &&
			css`
				content: '\\e957';
			`}
    
    font-family: "pyticon";
		position: absolute;
		right: 8px;
		top: 50%;
		font-size: 16px;
		margin-top: -8px;
		line-height: 1;
		color: #999999;
		pointer-events: none;
	}
`

const Select = styled.select`
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: 2px;
	padding: ${props =>
		props.templateTwo ? '4px 28px 4px 14px' : '4px 32px 4px 8px'};
	background-color: #ffffff;
	color: #148099;
	font-size: 15px;
	line-height: 20px;
	letter-spacing: -0.231818px;
	height: 32px;
	cursor: pointer;
	outline: 0 none;
	-webkit-appearance: none;
	-moz-appearance: none;
	-ms-appearance: none;
	appearance: none;
`
// CHILD AGES STYLES ENDS

const ChildCountText = styled.p`
	font-size: 17px;
	line-height: 1.41;
	letter-spacing: -0.25px;

	font-weight: 600;
	color: #333333;
	${props =>
		props.border &&
		css`
			border-top: 1px solid rgba(0, 0, 0, 0.1);
			padding: 20px 0 18px 0;
			margin: 0;
		`}
	${props =>
		!props.border &&
		css`
			margin: 0 0 18px 0;
		`}
`

const OptionText = styled.p`
	color: #777;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: -0.02em;
`

export const RenderAge = ({
	headerText = 'Child’s age',
	paxCount = [],
	onSelectAction = () => {},
	template = '',
	paxType = 'child',
}) => {
	const paxCountLength = paxCount.length
	const templateTwo = template === 'PACKAGE_V2'
	const paxTypeText =
		paxType.toLowerCase() === 'child'
			? paxCountLength > 1
				? 'Children'
				: 'Child'
			: paxCountLength > 1
			? 'Adults'
			: 'Adult'
	const optionsArray =
		paxType.toLowerCase() === 'child'
			? [...Array(16).keys()].map(index => index)
			: [...Array(87).keys()].map(index => index + 14)

	if (!paxCountLength) {
		return null
	}

	return (
		<RenderAgeWrapper templateTwo={templateTwo}>
			{templateTwo ? (
				<Fragment>
					<ChildCountText border={paxType.toLowerCase() === 'child'}>
						{paxCountLength} {paxTypeText}
					</ChildCountText>
					<OptionText>Choose {paxTypeText.toLowerCase()} age</OptionText>
				</Fragment>
			) : (
				<HeadingText>
					<i className="pyt-baby-16" />
					{headerText}
				</HeadingText>
			)}

			{paxCount.map((child, index) => {
				return (
					<SelectWrapper key={index} templateTwo={templateTwo}>
						<Select
							onChange={e => {
								onSelectAction({
									age: +e.target.value,
									childIndex: index,
								})
							}}
							templateTwo={templateTwo}
						>
							<option value="true">—</option>
							{optionsArray.map(age => {
								return (
									<option
										value={age}
										selected={age === parseInt(child, 10)}
										key={age}
									>
										{age
											? `${age} ${
													templateTwo ? (age > 1 ? 'years' : 'year') : ''
											  }`
											: '<1 year'}
									</option>
								)
							})}
						</Select>
					</SelectWrapper>
				)
			})}
		</RenderAgeWrapper>
	)
}
